module.exports = __webpack_public_path__ + "static/img/image-3.c3ecc119.png";